module.exports = __webpack_public_path__ + "img/b53e016ddea1b561a4994374d09bb382.png";